var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _c("div", { staticClass: "box-card" }, [
        _c(
          "p",
          [
            _vm._v("\n      保全章：\n      "),
            _c("el-switch", {
              attrs: {
                "active-color": _vm.activeColor,
                "active-value": _vm.activeVal,
                "inactive-value": _vm.inactiveVal
              },
              on: {
                change: function($event) {
                  return _vm.settingsChange($event, "presFlag")
                }
              },
              model: {
                value: _vm.settingsConfig.presFlag,
                callback: function($$v) {
                  _vm.$set(_vm.settingsConfig, "presFlag", $$v)
                },
                expression: "settingsConfig.presFlag"
              }
            })
          ],
          1
        ),
        _c("span", [
          _vm._v(
            "提示：开启时，合同第一页右上角会显示由君子签&易保全电子数据保全中心加盖的数据存证保全章，关闭则不显示。"
          )
        ])
      ]),
      _c("div", { staticClass: "box-card" }, [
        _c(
          "p",
          [
            _vm._v("\n      企业骑缝章：\n      "),
            _c("el-switch", {
              attrs: {
                "active-color": _vm.activeColor,
                "active-value": _vm.activeVal,
                "inactive-value": _vm.inactiveVal
              },
              on: {
                change: function($event) {
                  return _vm.settingsChange($event, "qifengFlag")
                }
              },
              model: {
                value: _vm.settingsConfig.qifengFlag,
                callback: function($$v) {
                  _vm.$set(_vm.settingsConfig, "qifengFlag", $$v)
                },
                expression: "settingsConfig.qifengFlag"
              }
            })
          ],
          1
        ),
        _c("span", [
          _vm._v(
            "提示：开启时，所有企业签署方在签署合同时会自动加盖骑缝章，关闭则不会加盖骑缝章。"
          )
        ])
      ]),
      _c("div", { staticClass: "box-card" }, [
        _c(
          "p",
          [
            _vm._v("\n      个人骑缝章：\n      "),
            _c("el-switch", {
              attrs: {
                "active-color": _vm.activeColor,
                "active-value": _vm.activeVal,
                "inactive-value": _vm.inactiveVal
              },
              on: {
                change: function($event) {
                  return _vm.settingsChange($event, "perQifengFlag")
                }
              },
              model: {
                value: _vm.settingsConfig.perQifengFlag,
                callback: function($$v) {
                  _vm.$set(_vm.settingsConfig, "perQifengFlag", $$v)
                },
                expression: "settingsConfig.perQifengFlag"
              }
            })
          ],
          1
        ),
        _c("span", [
          _vm._v(
            "提示：开启时，所有个人签署方在签署合同时会自动加盖骑缝章，关闭则不会加盖骑缝章。"
          )
        ])
      ]),
      _c("div", { staticClass: "box-card" }, [
        _c(
          "p",
          [
            _vm._v("\n      个人图形章：\n      "),
            _c("el-switch", {
              attrs: {
                "active-color": _vm.activeColor,
                "active-value": _vm.activeVal,
                "inactive-value": _vm.inactiveVal
              },
              on: {
                change: function($event) {
                  return _vm.settingsChange($event, "perSealFlag")
                }
              },
              model: {
                value: _vm.settingsConfig.perSealFlag,
                callback: function($$v) {
                  _vm.$set(_vm.settingsConfig, "perSealFlag", $$v)
                },
                expression: "settingsConfig.perSealFlag"
              }
            })
          ],
          1
        ),
        _c("span", [
          _vm._v(
            "提示：开启时，所有个人签署方在签署合同时，仅可使用图形章，关闭则可选择使用手写签字或图形章"
          )
        ])
      ]),
      _c("div", { staticClass: "box-card" }, [
        _c(
          "p",
          [
            _vm._v("\n      签章时间：\n      "),
            _c("el-switch", {
              attrs: {
                "active-color": _vm.activeColor,
                "active-value": _vm.activeVal,
                "inactive-value": _vm.inactiveVal
              },
              on: {
                change: function($event) {
                  return _vm.settingsChange($event, "timeFlag")
                }
              },
              model: {
                value: _vm.settingsConfig.timeFlag,
                callback: function($$v) {
                  _vm.$set(_vm.settingsConfig, "timeFlag", $$v)
                },
                expression: "settingsConfig.timeFlag"
              }
            })
          ],
          1
        ),
        _c("span", [
          _vm._v(
            "提示：开启时，所有签署方的签章左下角会展示合同签署日期，关闭则所有签署方的签章不显示签署时间。"
          )
        ])
      ]),
      _c("div", { staticClass: "box-card" }, [
        _c(
          "p",
          [
            _vm._v("\n      文件水印：\n      "),
            _c("el-switch", {
              attrs: {
                "active-color": _vm.activeColor,
                "active-value": _vm.activeVal,
                "inactive-value": _vm.inactiveVal
              },
              on: {
                change: function($event) {
                  return _vm.settingsChange($event, "waterFlag")
                }
              },
              model: {
                value: _vm.settingsConfig.waterFlag,
                callback: function($$v) {
                  _vm.$set(_vm.settingsConfig, "waterFlag", $$v)
                },
                expression: "settingsConfig.waterFlag"
              }
            }),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "10px" },
                attrs: { type: "small" },
                on: {
                  click: function($event) {
                    _vm.waterVisi = true
                  }
                }
              },
              [_vm._v("设置")]
            )
          ],
          1
        ),
        _c("span", [
          _vm._v(
            "提示：开启时，设置好的水印会在合同发起后添加在所有已上传的签署文件中。"
          )
        ])
      ]),
      _c("div", { staticClass: "box-card" }, [
        _c(
          "p",
          [
            _vm._v("\n      数字证书：\n      "),
            _c("el-switch", {
              attrs: {
                "active-color": _vm.activeColor,
                "active-value": _vm.activeVal,
                "inactive-value": _vm.inactiveVal
              },
              on: {
                change: function($event) {
                  return _vm.settingsChange($event, "certFlag")
                }
              },
              model: {
                value: _vm.settingsConfig.certFlag,
                callback: function($$v) {
                  _vm.$set(_vm.settingsConfig, "certFlag", $$v)
                },
                expression: "settingsConfig.certFlag"
              }
            })
          ],
          1
        ),
        _c("span", [
          _vm._v(
            "测试签约流程时，可关闭数字证书，正式签署时带数字证书可进一步保障签约有效性。"
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          attrs: { title: "添加水印", width: "60%", visible: _vm.waterVisi },
          on: {
            "update:visible": function($event) {
              _vm.waterVisi = $event
            }
          }
        },
        [
          _c("waterMark", {
            attrs: {
              visible: _vm.waterVisi,
              waterConfig: _vm.settingsConfig.waterSetting
            },
            on: {
              "update:visible": function($event) {
                _vm.waterVisi = $event
              },
              "update:waterConfig": function($event) {
                return _vm.$set(_vm.settingsConfig, "waterSetting", $event)
              },
              "update:water-config": function($event) {
                return _vm.$set(_vm.settingsConfig, "waterSetting", $event)
              },
              settingWater: _vm.settingWater
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "com-title com-ht" }, [
      _c("i"),
      _vm._v("签署设置\n  ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24e78a18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24e78a18","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/tpl/components/settings.vue
// module id = vH+B
// module chunks = 93 173